<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fAX5px/tc-custom/9781558618794.jpg?1704825515000" alt="This image is the cover for the book Silences"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Silences
      </h1>
      <p class="bookDescription body article font2">
        <b>A landmark survey of disenfranchised literary voices and the forces that seek to silence them—from the influential activist and author of <i>Tell Me a Riddle</i>.</b><br/>  <br/> With this groundbreaking work, Olsen revolutionized the study of literature by shedding critical light on the writings of marginalized women and working-class people. From the excavated testimony of authors’ letters and diaries, Olsen shows us the many ways the creative spirit, especially in those disadvantaged by gender, class, or race, has been suppressed through the years. Olsen recounts the torments of Herman Melville, the shame that brought Willa Cather to a dead halt, and the struggles of Olsen’s personal heroine Virginia Woolf, the greatest exemplar of a writer who confronted the forces that worked to silence her.<br/>  <br/> First published in 1978, <i>Silences</i> expanded the literary canon and the ways readers engage with literature. This 25th-anniversary edition includes Olsen’s classic reading lists of forgotten authors and a new introduction. Bracing and prescient, <i>Silences</i> remains “of primary importance to those who want to understand how art is generated or subverted and to those trying to create it themselves” (Margaret Atwood, <i>The New York Times Book Review</i>).<br/>  <br/> “A valuable book, an angry book, a call to action.” —Maxine Hong Kingston<br/>  <br/> “<i>Silences</i> helped me to keep my sanity many a day.” —Gloria Naylor, author of <i>Mama Day</i><br/>  <br/> “[<i>Silences</i> is] ‘the Bible.’ I constantly return to it.” —Sandra Cisneros, author of <i>The House on Mango Street</i><br/>  <br/> “<i>Silences</i> will, like <i>A Room of One’s Own</i>, be quoted where there is talk of the circumstances in which literature is possible.” —Adrienne Rich, author of <i>Diving into the Wreck</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tillie Olsen, Shelley Fisher Fishkin
      </h2>
      
      <p class="authorDescription body article">Activist and author Tillie Olsen is best known for her prize-winning fiction Tell Me a Riddle and Yonnondio: From the Thirties. She taught at MIT, Stanford, and Amherst. Olsen is an recipient of an Award for Distinguished Contribution to American Literature from the American Academy and the National Institute of Arts and Letters.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Feminist Press at CUNY
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60ab750a